<button (click)="valueChange(!value)">
  <i *ngIf="value" class="icon-accept"></i>
  <i *ngIf="!value" class="icon-none"></i>
</button>
